var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhyMsPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1176,
    height: 559,
    viewBox: "0 0 1176 559",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M953.771 17.9703C923.66 -91.1269 765.52 -134.704 654.215 -112.677C525.95 -87.2795 490.873 19.1202 389.028 7.54403C296.093 -2.9873 277.818 -97.0374 210.165 -99.8929C147.99 -102.514 60.4602 -27.4403 -57.7997 285.974",
    stroke: "url(#paint0_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-48.4573 297.698C68.4554 -11.2503 155.736 -88.5527 218.416 -88.6368C264.881 -88.6337 288.667 -45.72 329.065 -16.2034C349.305 -0.907044 372.937 8.68501 397.838 11.7116C479.412 21.6903 518.631 -40.9951 599.047 -79.6339C619.535 -89.551 640.979 -96.8993 662.936 -101.528C774.45 -125.433 929.639 -91.0061 961.484 13.5949",
    stroke: "url(#paint1_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-39.103 309.379C76.4652 4.91348 163.444 -74.5886 226.506 -77.3352C272.862 -79.35 297.383 -38.8277 337.603 -11.1579C358.176 3.39236 381.729 12.6501 406.465 15.9096C486.967 26.5019 526.903 -30.8154 607.758 -68.4273C628.299 -78.0333 649.659 -85.3743 671.496 -90.3328C783.288 -115.754 935.454 -90.8591 969.034 9.24662",
    stroke: "url(#paint2_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-29.7736 321.025C84.4218 21.1049 171.157 -60.5882 234.665 -66.0685C280.954 -70.0693 306.133 -31.9636 346.231 -6.13118C367.096 7.66973 390.554 16.6041 415.11 20.1024C494.612 31.295 535.098 -20.6435 616.486 -57.2262C637.083 -66.5738 658.382 -73.9324 680.12 -79.2115C792.142 -106.357 941.315 -90.7823 976.63 4.82852",
    stroke: "url(#paint3_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.4325 332.769C92.4108 37.2697 178.834 -46.5632 242.843 -54.7874C289.014 -60.745 314.941 -25.0722 354.892 -1.13148C376.064 11.9266 399.469 20.5445 423.881 24.2709C502.384 36.0638 543.478 -10.4871 625.432 -46.0669C646.049 -55.0947 667.244 -62.4368 688.827 -68.0281C801.098 -96.9015 947.281 -90.6279 984.348 0.485598",
    stroke: "url(#paint4_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.1715 344.486C100.38 53.4318 186.308 -34.4276 251.018 -43.5333C297.2 -50.0868 323.73 -18.3233 363.518 3.88708C384.983 16.1748 408.334 24.4753 432.597 28.4427C510.1 40.8361 551.765 -0.320929 634.162 -34.8555C654.808 -43.6177 675.926 -50.9692 697.383 -56.8643C809.892 -87.5435 953.093 -90.5131 991.898 -3.87326",
    stroke: "url(#paint5_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.74774 356.174C108.369 69.6092 194.204 -18.3943 259.16 -32.374C305.07 -42.0038 332.57 -11.4671 372.165 8.91983C393.9 20.4353 417.201 28.4253 441.315 32.6321C517.819 45.6262 560.108 9.83367 642.965 -23.6592C663.645 -32.1328 684.69 -39.4818 706.017 -45.6772C818.775 -78.0853 958.977 -90.4339 999.523 -8.22871",
    stroke: "url(#paint6_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58461 367.879C116.3 85.7784 201.855 -4.41245 267.349 -21.005C313.094 -32.6625 341.422 -4.79096 380.806 13.9143C402.794 24.6463 426.052 32.3178 450.021 36.7446C525.511 50.362 568.428 19.973 651.756 -12.5395C671.148 -20.08 691.908 -27.7149 714.638 -34.5858C827.654 -68.7842 964.867 -90.2969 1007.14 -12.6231",
    stroke: "url(#paint7_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9131 379.583C124.321 101.943 209.532 9.77302 275.496 -9.7964C321.117 -23.3117 350.293 1.89175 389.478 18.8735C411.719 28.8141 434.951 36.1895 458.786 40.8768C533.276 55.0952 576.778 30.0584 660.608 -1.38102C680.124 -8.70718 700.834 -16.2938 723.337 -23.4596C836.452 -59.3996 970.754 -90.1908 1014.76 -17.0281",
    stroke: "url(#paint8_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2569 391.264C132.304 118.095 217.204 23.9188 283.674 1.50391C329.156 -13.8467 359.259 8.59432 398.067 23.9054C420.532 33.0513 443.736 40.1374 467.43 45.0883C540.94 59.9044 585.05 40.2556 669.346 9.75752C688.893 2.66255 709.622 -4.92789 731.901 -12.3693C845.375 -50.1982 976.625 -90.2036 1022.37 -21.5136",
    stroke: "url(#paint9_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5822 402.969C140.265 134.248 224.878 38.0989 291.787 12.7514C337.134 -4.41576 368.086 15.2377 406.672 28.9284C429.354 37.2522 452.544 44.0391 476.105 49.2491C548.597 64.6701 593.313 50.3903 678.12 21.0229C697.795 14.1808 718.467 6.58057 740.507 -1.11401C854.211 -40.809 982.471 -90.002 1029.99 -25.8103",
    stroke: "url(#paint10_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9044 414.673C148.244 150.413 232.586 52.2677 299.989 23.9766C345.22 5.00841 377.035 21.8321 415.326 33.9158C437.337 40.8533 459.852 47.7967 484.849 53.3904C556.341 69.3938 601.668 60.5223 686.951 32.1729C706.716 25.5711 727.349 17.9576 749.204 9.99972C863.14 -31.5622 988.426 -89.9482 1037.66 -30.2253",
    stroke: "url(#paint11_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2256 426.377C156.23 166.633 240.172 66.4932 308.138 35.2249C353.251 14.4357 385.978 28.3806 423.962 38.8991C446.377 45.1095 468.905 51.7345 493.558 57.5312C564.059 74.1945 609.965 70.6391 695.747 43.3234C715.603 36.9811 736.216 29.3509 757.792 21.127C871.936 -22.3381 994.274 -89.8844 1045.25 -34.6337",
    stroke: "url(#paint12_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5063 438.088C164.176 182.719 247.956 80.6971 316.284 46.4682C361.287 23.9152 394.916 34.9037 432.598 43.8955C455.43 49.3365 477.955 55.6659 502.193 61.6984C571.706 78.9028 618.193 80.8031 704.545 54.5075C724.506 48.3827 745.062 40.7424 766.42 32.2808C880.786 -13.1304 1000.16 -89.8365 1052.87 -39.0582",
    stroke: "url(#paint13_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8733 449.763C172.146 198.856 255.617 94.9571 324.444 57.6813C369.353 33.3409 403.862 41.3565 441.21 48.8475C464.457 53.4998 487.021 59.5655 510.968 65.7912C579.447 83.6051 626.576 90.8718 713.336 65.6262C734.222 59.3041 754.82 51.8548 775.051 43.3076C889.615 -3.9479 1006.1 -89.7731 1060.49 -43.5151",
    stroke: "url(#paint14_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M82.183 461.468C180.113 215.009 263.411 109.126 332.527 68.9003C377.345 42.791 412.748 47.791 449.856 53.8025C473.516 57.6467 496.082 63.4555 519.669 69.9073C587.168 88.3213 634.888 100.985 722.09 76.7636C742.998 70.7363 763.558 63.2903 783.643 54.4718C898.427 5.1094 1011.93 -89.7418 1068.12 -48.0474",
    stroke: "url(#paint15_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4881 473.173C188.056 231.141 271.219 123.424 340.733 80.0868C385.429 52.2528 421.734 54.1557 458.46 58.7337C482.53 61.7502 505.107 67.3601 528.349 74.0155C594.832 93.0368 643.177 111.074 730.914 87.8787C751.84 82.1211 772.362 74.6577 792.297 65.5552C907.237 14.2942 1017.81 -89.7174 1075.75 -52.4386",
    stroke: "url(#paint16_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.706 484.873C195.934 247.237 278.786 137.498 348.789 91.0874C393.453 61.456 430.588 60.254 466.999 63.4475C491.548 65.5851 514.084 71.009 536.987 77.8911C602.473 97.4885 651.42 120.979 739.665 98.8039C760.607 93.3015 781.096 85.8155 800.885 76.4362C916.015 23.1427 1023.68 -90.0373 1083.36 -57.2156",
    stroke: "url(#paint17_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M109.896 496.578C203.687 263.179 286.458 151.591 356.862 102.137C401.464 70.751 439.424 66.4009 475.564 68.2592C500.474 69.5982 523.108 74.7702 545.633 81.8669C610.135 102.119 659.691 130.989 748.42 109.782C769.377 104.535 789.836 97.0254 809.476 87.3695C924.795 32.0205 1029.65 -90.2628 1090.99 -61.9456",
    stroke: "url(#paint18_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M119.079 508.283C211.611 279.196 294.143 165.686 364.894 113.056C409.467 79.8866 448.229 72.3484 484.093 72.8308C509.395 73.1856 532.043 78.2999 554.249 85.64C617.742 106.512 667.911 140.79 757.155 120.645C778.129 115.664 798.562 108.129 818.049 98.1879C933.531 40.726 1035.41 -90.7208 1098.59 -66.8518",
    stroke: "url(#paint19_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M128.276 519.964C219.458 295.216 301.839 179.886 372.877 124.049C417.408 89.136 456.95 78.3699 492.546 77.5325C518.242 76.9212 540.935 81.932 562.775 89.445C625.298 110.95 676.084 150.662 765.817 131.526C786.808 126.792 807.223 119.23 826.567 109.022C942.1 49.3072 1041.2 -91.0531 1106.16 -71.7066",
    stroke: "url(#paint20_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M137.436 531.671C283.22 173.951 409.016 87.764 501.16 82.2041C601.747 76.1316 652.837 166.865 774.631 142.447C917.503 113.782 1035.84 -93.9505 1113.8 -76.5655",
    stroke: "url(#paint21_linear_1400_3894)",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1400_3894",
    x1: 408.205,
    y1: -138.399,
    x2: 468.638,
    y2: 188.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1400_3894",
    x1: 417.822,
    y1: -126.772,
    x2: 478.263,
    y2: 200.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1400_3894",
    x1: 427.353,
    y1: -115.231,
    x2: 487.813,
    y2: 212.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1400_3894",
    x1: 436.883,
    y1: -103.824,
    x2: 497.379,
    y2: 223.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1400_3894",
    x1: 446.453,
    y1: -92.5372,
    x2: 507.023,
    y2: 235.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1400_3894",
    x1: 455.872,
    y1: -81.4606,
    x2: 516.553,
    y2: 246.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1400_3894",
    x1: 465.396,
    y1: -70.5043,
    x2: 526.206,
    y2: 258.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1400_3894",
    x1: 474.871,
    y1: -59.5632,
    x2: 535.814,
    y2: 270.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1400_3894",
    x1: 484.302,
    y1: -48.9374,
    x2: 545.436,
    y2: 281.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1400_3894",
    x1: 493.732,
    y1: -38.3894,
    x2: 555.068,
    y2: 293.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1400_3894",
    x1: 503.109,
    y1: -28.0872,
    x2: 564.696,
    y2: 305.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1400_3894",
    x1: 512.492,
    y1: -18.0018,
    x2: 574.369,
    y2: 316.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1400_3894",
    x1: 521.798,
    y1: -8.14284,
    x2: 584.009,
    y2: 328.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1400_3894",
    x1: 531.068,
    y1: 1.46585,
    x2: 593.66,
    y2: 340.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1400_3894",
    x1: 540.337,
    y1: 10.7226,
    x2: 603.37,
    y2: 351.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1400_3894",
    x1: 549.539,
    y1: 19.6357,
    x2: 613.079,
    y2: 363.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1400_3894",
    x1: 558.675,
    y1: 28.1548,
    x2: 622.798,
    y2: 374.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1400_3894",
    x1: 566.461,
    y1: 26.9024,
    x2: 632.975,
    y2: 386.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1400_3894",
    x1: 574.115,
    y1: 24.7846,
    x2: 643.184,
    y2: 397.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1400_3894",
    x1: 581.683,
    y1: 22.046,
    x2: 653.422,
    y2: 409.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1400_3894",
    x1: 589.202,
    y1: 19.0107,
    x2: 663.664,
    y2: 420.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1400_3894",
    x1: 596.696,
    y1: 15.6705,
    x2: 673.942,
    y2: 432.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyMsPattern);
export default __webpack_public_path__ + "static/media/whyMsPattern.464ff4cc5ae8118c90590f4eebcbc137.svg";
export { ForwardRef as ReactComponent };